import { appSystemKey, parseAppSystem } from "nlb-buy-go-library-v2";
import { createApp, ComponentPublicInstance } from "vue";
import App from "@/app/app.vue";
import { i18n } from "@app/i18n";
import vuetify from "@app/plugins/vuetify";
import { loadFonts } from "@app/plugins/webfontloader";
import { createPinia } from "pinia";
import router from "@app/router";

import Datepicker from "@vuepic/vue-datepicker";
import * as Sentry from "@sentry/vue";

loadFonts()

  const app = createApp(App);
  app.provide(appSystemKey, parseAppSystem(import.meta.env.MODE));

  if (import.meta.env.MODE === "PROD") {
    Sentry.init({
        app,
        release: `${__APP_VERSION__}`,
        dsn: "https://c2b729cdea353b5f6b7a9dac9fbbfc76@o4509208598806528.ingest.de.sentry.io/4509208649793616",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true
      });
   }

  app.component("Datepicker", Datepicker)
  .use(vuetify)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .mount("#app");

  console.log("version: " + `${__APP_VERSION__}`);
